export const AZURE_SAS_TOKEN_SUBS_STRING = 'core.windows.net';
